module.exports = __webpack_public_path__ + "00a2c5d37dd540ff627834b02ee8176f.svg";